import { AUTH_MODE, devUser, getToken } from './auth';

const BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';

export class ApiError extends Error { constructor(public status: number, message: string) { super(message); } }

async function headers(extra: Record<string, string> = {}): Promise<Record<string, string>> {
  const h: Record<string, string> = { ...extra };
  if (AUTH_MODE === 'dev') { const u = devUser(); h['x-dev-user'] = JSON.stringify({ oid: u.oid, upn: u.upn, name: u.name, roles: u.roles }); }
  else { const t = await getToken(); if (t) h.Authorization = `Bearer ${t}`; }
  return h;
}

async function handle<T>(res: Response): Promise<T> {
  if (!res.ok) {
    let msg = res.statusText;
    try { msg = ((await res.json()) as { error?: string }).error ?? msg; } catch { /* not json */ }
    throw new ApiError(res.status, msg);
  }
  return (res.status === 204 ? undefined : await res.json()) as T;
}

export const api = {
  async get<T>(path: string): Promise<T> { return handle<T>(await fetch(BASE + path, { headers: await headers() })); },
  async send<T>(method: 'POST' | 'PUT' | 'PATCH' | 'DELETE', path: string, body?: unknown): Promise<T> {
    return handle<T>(await fetch(BASE + path, { method, headers: await headers(body === undefined ? {} : { 'Content-Type': 'application/json' }), body: body === undefined ? undefined : JSON.stringify(body) }));
  },
  async upload<T>(path: string, form: FormData): Promise<T> { return handle<T>(await fetch(BASE + path, { method: 'POST', headers: await headers(), body: form })); },
  /** Fetch a file with auth and open it in a new tab (links can't carry the token). */
  async openFile(path: string): Promise<void> {
    const res = await fetch(BASE + path, { headers: await headers() });
    if (!res.ok) throw new ApiError(res.status, 'Could not open the file');
    const url = URL.createObjectURL(await res.blob());
    window.open(url, '_blank', 'noopener');
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  },
  /** Unauthenticated calls for the public signing page. */
  async public<T>(method: 'GET' | 'POST', path: string, body?: unknown): Promise<T> {
    return handle<T>(await fetch(BASE + path, { method, headers: body === undefined ? {} : { 'Content-Type': 'application/json' }, body: body === undefined ? undefined : JSON.stringify(body) }));
  },
};
